import ActivityComponent from './activity.component'

const ActivityModule = angular.module('cdbl.activity', [

])
  .component('cdblActivity', ActivityComponent)
  .name

export default ActivityModule
